const buildItemsDepthMap = (flatTree, rootId) => {
  const idToNodeMap = new Map();
  const idToDepthMap = new Map();

  flatTree.forEach((node) => {
    idToNodeMap.set(node.id, node);
    idToDepthMap.set(node.id, { depth: 1, maxChildDepth: 0 });
  });

  const getDepth = (nodeId) => {
    const node = idToNodeMap.get(nodeId);
    if (!node || node.parent === rootId) return 1;
    return 1 + getDepth(node.parent);
  };

  flatTree.forEach((node) => {
    idToDepthMap.set(node.id, { depth: getDepth(node.id), maxChildDepth: 0 });
  });

  const getAncestorIds = (nodeId) => {
    const node = idToNodeMap.get(nodeId);
    if (!node || node.parent === rootId || !idToNodeMap.has(node.parent)) return [];
    return [node.parent, ...getAncestorIds(node.parent)];
  };

  flatTree.forEach((node) => {
    const nodeDepth = idToDepthMap.get(node.id).depth;

    getAncestorIds(node.id).forEach((ancestorId) => {
      const ancestorEntry = idToDepthMap.get(ancestorId);
      if (!ancestorEntry) return;

      const childDepth = nodeDepth - ancestorEntry.depth;
      if (childDepth > ancestorEntry.maxChildDepth) {
        ancestorEntry.maxChildDepth = childDepth;
      }
    });
  });

  return idToDepthMap;
};

export default buildItemsDepthMap;
